<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useAuthStore } from "../store/auth";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ArgonButton from "@/components/ArgonButton.vue";
import FullScreenLoader from "@/components/FullScreenLoader.vue";
import { loaderState, showLoader, hideLoader } from "../utils/loader/loader.js";
import imgHeader from "../assets/img/shapes/fondo-ontrix-horizontal.jpg";


const body = document.getElementsByTagName("body")[0];
const authStore = useAuthStore();
const router = useRouter();
const inputValues = ref(["", "", "", "", "", ""]);
const headerIMG = ref(imgHeader);

const moveToNextInput = (index, event) => {
  const value = event.target.value;
  if (value.length >= 1 && index < inputValues.value.length - 1) {
    document.getElementById(`input-${index + 1}`).focus();
  }
};

const handleInputChange = (index, event) => {
  const value = event.target.value.replace(/\D/g, ""); // Permitir solo números
  inputValues.value[index] = value.substring(0, 1); // Limitar a un dígito
};

const submitForm = async () => {
  showLoader();
  const concatenatedCode = inputValues.value.join("");

  const response = await authStore.code(concatenatedCode);
  if (response.ok) {
    router.push("dashboard");
  } else {
    toast.error(response.message);
  }
  hideLoader();
};

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
</script>
<template>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="background-position: top"
      :style="{
        backgroundImage: `url(${headerIMG})`,
      }"
    >
      <!-- <span class="mask bg-gradient-dark opacity-6"></span> -->
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5">¡Bienvenido!</h1>
            <p class="text-lead text-white">
              Por favor, ingresa el código enviado a tu  correo
              electrónico para continuar.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xs-10 col-md-10 col-lg-4">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <h5>Ingresa la información</h5>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <input
                  v-for="(value, index) in inputValues"
                  :key="index"
                  :id="`input-${index}`"
                  type="text"
                  maxlength="1"
                  class="form-control text-center mx-1"
                  style="font-size: 24px"
                  v-model="inputValues[index]"
                  @input="handleInputChange(index, $event)"
                  @keyup="moveToNextInput(index, $event)"
                />
              </div>
              <div class="text-center mt-4">
                <argon-button fullWidth class="my-4 mb-2" @click="submitForm"
                  >Continuar</argon-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <full-screen-loader :isVisible="loaderState.isVisible" />
  </main>
  <!-- <app-footer /> -->
</template>
